import MenuItems from "./MenuItems";

const CompanyDropdown = ({ menuItems, handleChosenCompany }: any) => {
  return (
    <>
      {menuItems?.map((menu: Object, index: number) => {
        const depthLevel = 0;
        return (
          <MenuItems
            items={menu}
            key={index}
            depthLevel={depthLevel}
            handleChosenCompany={(item: any) => handleChosenCompany(item)}
          />
        );
      })}
    </>
  );
};

export default CompanyDropdown;
